import React from 'react';
import Conjugation from '../components/Conjugation';
import data from './dataJson';

const Type28 = () => {
  return <Conjugation data={data} />;
};

export default Type28;
